import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/frame/Login';
import Index from './views/frame/Index';
import Main from './views/frame/Main';
import AccountManager from './views/security/AccountManager';
import PhysicGraph from './views/topo/TopoMonitor/PhysicGraph';
import LogicalGraph from './views/topo/TopoMonitor/LogicalGraph';
import DeviceManage from './views/topo/ResourceManage/DeviceManage';
import NeManage from './views/topo/ResourceManage/NeManage';
import TrunkManage from './views/topo/ResourceManage/TrunkManage';
import MML from './views/mmlconfig/MML';
import CurrentAlarm from './views/alarm/CurrentAlarmPage';
import HistoryAlarm from './views/alarm/HistoryAlarmPage';
import SystemManager from './views/system/MissionManager';
import EventLog from './views/alarm/EventLogPage';
import BlockingRule from './views/alarm/BlockingRulePage';
import AlarmNotice from './views/alarm/AlarmNoticePage';
import MCSUserMain from './views/subscriber/mcsSubscriber/user/UserMainPage';
import MCSGroupMain from './views/subscriber/mcsSubscriber/group/GroupMainPage';
import PDNProfileMain from './views/subscriber/epcSubscriber/pdn/PDNMainPage';
import DNNProfileMain from './views/subscriber/udmSubscriber/dnn/DNNMainPage';
import SnssaiMainPage from './views/subscriber/udmSubscriber/snssai/SnssaiMainPage';
import AmDataMainPage from './views/subscriber/udmSubscriber/amdata/AmDataMainPage';
import PlmnMainPage from './views/subscriber/udmSubscriber/plmn/PlmnMainPage';
import UsersubMainPage from './views/subscriber/udmSubscriber/usersub/UsersubMainPage';
import SupiMainPage from './views/subscriber/udmSubscriber/supi/SupiMainPage';
import ProfileMain from './views/subscriber/epcSubscriber/profile/ProfileMainPage';
import LTEUserMain from './views/subscriber/epcSubscriber/user/UserMainPage';

import DataManager from './views/system/DataManager';
import AdapterPkg from './views/system/AdapterPkg';
import AddressBook from './views/system/AddressBook';
import HistoryMail from './views/system/HistoryMail';
import MailServer from './views/system/MailServer';
import Personal from './views/system/Personal';
import MapConfig from './views/system/MapConfig';
import AlarmRedirect from './views/alarm/AlarmRedirectPage';
import imsUserManagement from './views/subscriber/imsSubscriber/user/imsUserManagement';
import GroupManagement from './views/subscriber/imsSubscriber/group/GroupManagement';
import VersionUpdate from './views/software/VersionUpdate';
import VersionBack from './views/software/VersionBack';
import VersionLib from './views/software/VersionLib';
import TscIpAutoDistributePage from './views/software/TscIpAutoDistributePage';
import VersionQuery from './views/software/VersionQuery';
import AppUpdate from './views/software/AppUpdate';

import NoRealTaskPage from './views/pm/NoRealTaskPage';
import NoRealQueryPage from './views/pm/NoRealQueryPage';
import KpiChartShowPage from './views/pm/KpiChartShowPage';
import RealTimeTaskPage from './views/pm/RealTimeTaskPage';
import IndicatorManagementPage from './views/pm/IndicatorManagementPage';
import RoleManager from './views/security/RoleManager';
import StrategyManager from './views/security/StrategyManager';
import SignalTrack from './views/track/SignalTrackPage';
import UserTrack from './views/track/UserTrackPage';
import MonitTrack from './views/track/MonitTrackPage';
import ImportTrack from './views/track/ImportTrackPage';
import TrafficTask from './views/ts/hytalk/TrafficTaskPage';
import SystemCallTimeCharts from './views/ts/hytalkPro/systemStatistics/SystemCallTimeChartsPage';
import SystemCallTimeSingle from './views/ts/hytalkPro/systemStatistics/SystemCallTimeSinglePage';
import SystemCallTimeGroup from './views/ts/hytalkPro/systemStatistics/SystemCallTimeGroupPage';
import SystemCallNumCharts from './views/ts/hytalkPro/systemStatistics/SystemCallNumChartsPage';
import SystemCallNumSingle from './views/ts/hytalkPro/systemStatistics/SystemCallNumSinglePage';
import SystemCallNumGroup from './views/ts/hytalkPro/systemStatistics/SystemCallNumGroupPage';
import VPNCallStatistics from './views/ts/hytalkPro/vpnStatistics/VPNCallStatisticsPage';
import LogManager from './views/security/LogManager';
import ImsiTemplateManagement from './views/subscriber/imsSubscriber/template/ImsTemplateManagement';
import ImsInfoManagement from './views/subscriber/imsSubscriber/staff/ImsInfoManagement';
import DataManagement from './views/subscriber/datamanage/DataManagement';
import Spectrum from './views/spectrum/SpectrumPage';
import UEList from './views/ue/UeListPage';
import UeShowMap from "./views/ue/UeShowMap";
import LicenseManager from './views/security/LicenseManager';
import RackGraph from './views/topo/TopoMonitor/RackGraph.vue';
import DeployedInstance from './views/deploymentManagement/deployedInstanManagement/DeployedInstance.vue';
import ServerManagement from './views/deploymentManagement/serviceManagement/ServerManagement.vue';
import RunEnvironment from './views/deploymentManagement/runningEnvironment/RunEnvironment'
import ClientManager from './views/security/ClientManager'
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
import Threshold from './views/system/Threshold';
Vue.use(Router);

export default new Router({
  // mode: 'hash',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      children: [
        {
          path: '/main',
          name: 'main',
          component: Main
        },
        {
          path: '/mml',
          name: 'mml',
          component: MML
        },
        /*{
          path: '/ueList',
          name: 'ueList',
          component: UEList
        },*/
        {
          path: '/spectrum',
          name: 'spectrum',
          component: Spectrum
        },
      ]
    },
    {
      path:'/ue',
      name:'ue',
      component: Index,
      children: [
        {
          path: 'ueList',
          name: 'ueList',
          component: UEList
        },
        {
          path:'ueMap',
          name:'ueMap',
          component: UeShowMap
        }
      ]
    },
    {
      path: '/topo',
      name: 'topo',
      component: Index,
      children: [
        {
          path: 'physicGraph',
          name: 'physicGraph',
          component: PhysicGraph
        },
        {
          path: 'deviceManage',
          name: 'deviceManage',
          component: DeviceManage
        },
        {
          path: 'neManage',
          name: 'neManage',
          component: NeManage
        },
        // {
        //   path: 'trunkManage',
        //   name: 'trunkManage',
        //   component: TrunkManage
        // },
        {
          path: 'rackGraph',
          name: 'rackGraph',
          component: RackGraph
        },
        // 运行环境路由开发阶段 todo
        {
          path: 'runEnvironment',
          name: 'runEnvironment',
          component: RunEnvironment
        },
      ]
    },
    {
      path: '/micpoc',
      name: 'micpoc',
      component: Index,
      children: [
        {
          path: 'serverManagement',
          name: 'serverManagement',
          component: ServerManagement
        },
        {
          path: 'deployedInstance',
          name: 'deployedInstance',
          component: DeployedInstance
        },
        {
          path: 'environment',
          name: 'environment',
          component: RunEnvironment
        }
      ]
    },
    {
      path: '/alarm',
      name: 'alarm',
      component: Index,
      children: [
        {
          path: 'currentAlarm',
          name: 'currentAlarm',
          component: CurrentAlarm
        },
        {
          path: 'historyAlarm',
          name: 'historyAlarm',
          component: HistoryAlarm
        },
        {
          path: 'eventLog',
          name: 'eventLog',
          component: EventLog
        },
        {
          path: 'blockingRule',
          name: 'blockingRule',
          component: BlockingRule
        },
        {
          path: 'alarmNotice',
          name: 'alarmNotice',
          component: AlarmNotice
        },
        {
          path: 'alarmRedirect',
          name: 'alarmRedirect',
          component: AlarmRedirect
        }
      ]
    },
    {
      path: '/subscriber',
      name: 'subscriber',
      component: Index,
      children: [
        {
          path: 'lte/pdnProfile',
          name: 'pdnProfile',
          component: PDNProfileMain
        },
        {
          path: 'udm/dnnProfile',
          name: 'dnnProfile',
          component: DNNProfileMain
        },
        {
          path: 'udm/snssaiProfile',
          name: 'snssaiProfile',
          component: SnssaiMainPage
        },
        {
          path: 'udm/amdataProfile',
          name: 'amdataProfile',
          component: AmDataMainPage
        },
        {
          path: 'udm/plmnProfile',
          name: 'plmnProfile',
          component: PlmnMainPage
        },
        {
          path: 'udm/usersubProfile',
          name: 'usersubProfile',
          component: UsersubMainPage
        },
        {
          path: 'udm/supiProfile',
          name: 'supiProfile',
          component: SupiMainPage
        },
        {
          path: 'lte/profile',
          name: 'profile',
          component: ProfileMain
        },
        {
          path: 'lte/lteUser',
          name: 'lteUser',
          component: LTEUserMain
        },
        {
          path: 'mcs/mcsUser',
          name: 'mcsUser',
          component: MCSUserMain
        },
        {
          path: 'mcs/mcsGroup',
          name: 'mcsGroup',
          component: MCSGroupMain
        },
        {
          path: 'ims/imsUserManagement',
          name: 'imsUserManagement',
          component: imsUserManagement
        },
        {
          path: 'ims/groupManagement',
          name: 'groupManagement',
          component: GroupManagement
        },
        {
          path: 'ims/imsTemplateManagement',
          name: 'imsTemplateManagement',
          component: ImsiTemplateManagement
        },
        {
          path: 'ims/imsInfoManagement',
          name: 'imsInfoManagement',
          component: ImsInfoManagement
        },
        {
          path: 'dataManagement',
          name: 'dataManagement',
          component: DataManagement
        }
      ]
    },
    {
      path: '/ts',
      name: 'ts',
      component: Index,
      children: [
        {
          path: 'trafficTask',
          name: 'trafficTask',
          component: TrafficTask
        },
        {
          path: 'system/call/time/charts',
          name: 'SystemCallTimeCharts',
          component: SystemCallTimeCharts
        },
        {
          path: 'system/call/time/single',
          name: 'SystemCallTimeSingle',
          component: SystemCallTimeSingle
        },
        {
          path: 'system/call/time/group',
          name: 'SystemCallTimeGroup',
          component: SystemCallTimeGroup
        },
        {
          path: 'system/call/num/charts',
          name: 'SystemCallNumCharts',
          component: SystemCallNumCharts
        },
        {
          path: 'system/call/num/single',
          name: 'SystemCallNumSingle',
          component: SystemCallNumSingle
        },
        {
          path: 'system/call/num/group',
          name: 'SystemCallNumGroup',
          component: SystemCallNumGroup
        },
        {
          path: 'vpn/call/time/charts',
          name: 'vpnCallCount',
          component: VPNCallStatistics
        },
        {
          path: 'vpn/call/time/single',
          name: 'vpnCallSingleCount',
          component: VPNCallStatistics
        },
        {
          path: 'vpn/call/time/group',
          name: 'vpnCallGroupCount',
          component: VPNCallStatistics
        },
        {
          path: 'org/voice/charts/num',
          name: 'vpnCallDuration',
          component: VPNCallStatistics
        },
        {
          path: 'org/voice/single/num',
          name: 'vpnCallSingleDuration',
          component: VPNCallStatistics
        },
        {
          path: 'org/voice/group/num',
          name: 'vpnCallGroupDuration',
          component: VPNCallStatistics
        }
      ]
    },
    {
      path: '/pm',
      name: 'pm',
      component: Index,
      children: [
        {
          path: 'noRealTask',
          name: 'noRealTask',
          component: NoRealTaskPage
        },
        {
          path: 'noRealQuery',
          name: 'noRealQuery',
          component: NoRealQueryPage
        },
        {
          path: 'kpiChartShow',
          name: 'kpiChartShow',
          component: KpiChartShowPage
        },
        {
          path: 'realTimeTask',
          name: 'realTimeTask',
          component: RealTimeTaskPage
        },
        {
          path: 'indicatorManagement',
          name: 'indicatorManagement',
          component: IndicatorManagementPage
        }
      ]
    },
    {
      path: '/track',
      name: 'track',
      component: Index,
      children: [
        {
          path: 'signalTrack',
          name: 'signalTrack',
          component: SignalTrack
        },
        {
          path: 'userTrack',
          name: 'userTrack',
          component: UserTrack
        },
        {
          path: 'monitTrack',
          name: 'monitTrack',
          component: MonitTrack
        },
        {
          path: 'importTrack',
          name: 'importTrack',
          component: ImportTrack
        }
      ]
    },
    {
      path: '/software',
      name: 'software',
      component: Index,
      children: [
        {
          path: 'versionLib',
          name: 'versionLib',
          component: VersionLib
        },
        {
          path: 'versionUpdate',
          name: 'versionUpdate',
          component: VersionUpdate
        },
        {
          path: 'versionBack',
          name: 'versionBack',
          component: VersionBack
        },
        {
          path: 'tscIpAutoDistribute',
          name: 'tscIpAutoDistribute',
          component: TscIpAutoDistributePage
        },
        {
          path: 'appUpdate',
          name: 'appUpdate',
          component: AppUpdate
        },
        {
          path: 'versionQuery',
          name: 'versionQuery',
          component: VersionQuery
        }
      ]
    },
    {
      path: '/system',
      name: 'system',
      component: Index,
      children: [
        {
          path: 'systemManager/:id',
          name: 'systemManager',
          component: SystemManager,
        },
        {
          path: 'dataManager/:id',
          name: 'dataManager',
          component: DataManager,
        },
        {
          path: 'adapterManager',
          name: 'adapterManager',
          component: AdapterPkg,
        },
        {
          path: 'mailServer',
          name: 'mailServer',
          component: MailServer,
        },
        {
          path: 'historyMail',
          name: 'historyMail',
          component: HistoryMail,
        },
        {
          path: 'addressBook',
          name: 'addressBook',
          component: AddressBook,
        },
        {
          path: 'mapConfig',
          name: 'mapConfig',
          component: MapConfig,
        },
        {
          path: 'personal',
          name: 'personal',
          component: Personal,
        },
        {
          path: 'threshold',
          name: 'threshold',
          component: Threshold,
        }
      ]
    },
    {
      path: '/security',
      name: 'security',
      component: Index,
      children: [
        {
          path: 'accountManager',
          name: 'account',
          component: AccountManager
        },
        {
          path: 'roleManager',
          name: 'roleManager',
          component: RoleManager
        },
        {
          path: 'strategyManager',
          name: 'strategyManager',
          component: StrategyManager
        },
        {
          path: 'logManager/:id',
          name: 'logManager',
          component: LogManager
        },
        {
          path: 'license/:id',
          name: 'license',
          component: LicenseManager
        },
        {
          path: 'client',
          name: 'client',
          component: ClientManager
        }
      ]
    }
  ]
});
